import React from "react";
import {
  Button,
  Box,
} from '@mui/material';
import LogoHeader from "../../Shared/LogoHeader/LogoHeader";
import ActionFooter from "../../Shared/ActionFooter/ActionFooter";

const FirstStepTutorial = (props: any) => {
  const { showTutorial } = props;

  return (
    <Box
      component="div"
      className="tutorial"
    >
      <LogoHeader/>
      <div className="title" data-testid='welcoming-text-header'>Que bom ter você aqui!</div>
      <div className="description" data-testid='welcoming-text-description'>
        Com o Infovist Frotas ficou mais<br />fácil realizar vistorias em sequência
      </div>
      <img
        src="assets/images/offline-tutorial/car-group.png"
        alt="car-group"
        className="ilustration"
        data-testid='car-image'
      />
      <ActionFooter>
        <Button
          fullWidth
          className="black-button"
          data-testid='button'
          onClick={() => { showTutorial() }}
        >Próximo</Button>
      </ActionFooter>
    </Box>
  );
}

export default FirstStepTutorial;
